import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { DatePipe } from '@angular/common';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { DocumentosExService } from './documentosEx.service';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { SolicitudDocumentosExViewModel, TDocumentoSolicitudExViewModel } from './documentosEx.types';
import { EnumIdsTcEstadoCertificadoFitoEx, EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { HttpParams } from '@angular/common/http';
import { DocumentUploaderService } from '../../../core/components/uploader/document-uploader.service';
import { UploadedFileViewModel } from '../../../core/components/uploader/document_uploader.types';

@Component({
    selector: 'app-documentosex-list',
    templateUrl: './documentosEx-list.component.html',
    styleUrls: ['./documentosEx-list.component.scss'],
})
export class DocumentosExListComponent extends ComponentBase implements OnInit {
    solicitudDocumentoEx: SolicitudDocumentosExViewModel;
    //documento: TDocumentoSolicitudViewModel;
    uploadedFile: UploadedFileViewModel;

    habilitarGuardar = false;
    numeroDocumentos = 0;
    allDocumentosAlegacion = false;
    cols: any[];
    idSolicitudEx = 0;
    editMode = false;
    tituloTipoSolicitudEx: string;
    laHeGrabadoYo = false;
    documentoDescargable = false;
    documentoEditable = false;
    documentoBorrable = false;
    esClonada = false;

    documentosEstandar: TDocumentoSolicitudExViewModel[];
    tituloEstadoCertificadoFitoEx: string;
    IdTipoSolicitudEx: number;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private documentosExService: DocumentosExService,
        private confirmationService: ConfirmationService,
        private uploaderService: DocumentUploaderService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudDocumentoEx = new SolicitudDocumentosExViewModel();
        this.uploadedFile = new UploadedFileViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'AttachedEphyto', header: 'Adjuntado a ePhyto', display: 'none' },
            { field: 'Autogenerado', header: 'Autogenerado', display: 'none' },
            { field: 'IdTipoDocumentacionExDescripcion', header: 'Tipo' },
            { field: 'Texto', header: 'Número' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'Perfil', header: 'Perfil' },
        ];

        this.idSolicitudEx = this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitudEx);

        this.createForm();

        this.onSearchButton();
    }

    onSearchButton() {
        this.loading = true;

        //Para saber si se actúa como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitudEx', this.idSolicitudEx.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());
        this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
            this.laHeGrabadoYo = resultIsGrabada;

            this.documentosExService.getSolicitudDocumentos(this.idSolicitudEx).subscribe(result => {
                this.solicitudDocumentoEx = result;

                this.IdTipoSolicitudEx = this.solicitudDocumentoEx.IdTipoSolicitudEx;
                this.tituloTipoSolicitudEx = this.solicitudDocumentoEx.IdTipoSolicitudExDescripcion;
                this.tituloEstadoCertificadoFitoEx = this.solicitudDocumentoEx.IdEstadoCertificadoFitoExDescripcion;

                this.esClonada =
                    this.solicitudDocumentoEx.TwSolicitudJerarquiaEx != null &&
                    this.solicitudDocumentoEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;

                //SI ES PREVIA
                if (this.solicitudDocumentoEx.EsPrevia) {
                    if (
                        this.solicitudDocumentoEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.solicitudDocumentoEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitudEx += '-Previa';
                    }
                }

                //si no es Inspector entonces no podrá ver aquellos doc que lleven el flag VisibleInspector a True
                if (!this.isInspector || (this.isGrabador && this.isInspector && this.laHeGrabadoYo)) {
                    this.solicitudDocumentoEx.TDocumentoSolicitudExCollection = this.solicitudDocumentoEx.TDocumentoSolicitudExCollection!.filter(
                        r => r.VisibleInspector == false,
                    );
                }

                //Filtro los documentos que son estandar
                this.documentosEstandar = this.solicitudDocumentoEx.TDocumentoSolicitudExCollection.filter(x => x.EsAlegacion == false);
                this.allDocumentosAlegacion = this.solicitudDocumentoEx.TDocumentoSolicitudExCollection.every(x => x.EsAlegacion == true);
                this.numeroDocumentos = this.solicitudDocumentoEx.TDocumentoSolicitudExCollection!.length;

                //el icono de descargar aparecerá siempre que exista algún documento. La edición se gestiona a continuación
                this.documentoDescargable = this.numeroDocumentos > 0;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_EXPORTACION,
                    this.solicitudDocumentoEx.IdEstadoSolicitudEx,
                ).Visible;

                //Si soy Inspector-Grabador y la solicitud está en Revision Solicitante
                if (
                    this.isGrabador &&
                    this.isInspector &&
                    this.solicitudDocumentoEx.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE
                ) {
                    this.habilitarGuardar = this.habilitarGuardar && this.laHeGrabadoYo;
                }
                //estos perfiles siempre podrán descargar documentos
                if (this.isInspector || this.isCoordinador) {
                    this.documentoDescargable = true;
                }

                this.loading = false;
            });
        });
    }

    isDocumentoEditable(item: TDocumentoSolicitudExViewModel) {
        //Si soy Inspector-Grabador
        if (this.isGrabador && this.isInspector) {
            //estado solicitud es Revision Solicitante
            if (this.solicitudDocumentoEx.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE) {
                return this.checkEdit() && this.laHeGrabadoYo;
            }

            //estado CF
            if (this.solicitudDocumentoEx.IdEstadoCertificadoFitoEx != EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE) {
                //es posible que haya documentos ya adjuntados al ePhyto y esté enviado a Traces, entonces evitar editar/eliminar documentos. El inspector sólo puede editar los suyos NO adjuntados
                return this.checkEdit() && item.IdUsuario == this.loggedInUser?.Id && !item.AttachedEphyto && !item.Autogenerado;
            } else {
                return this.checkEdit();
            }
        } else {
            //es posible que haya documentos ya adjuntados al ePhyto y esté enviado a Traces, entonces evitar editar/eliminar documentos.
            return this.checkEdit() && !item.AttachedEphyto && !item.Autogenerado;
        }
    }

    isDocumentoBorrable(item: TDocumentoSolicitudExViewModel) {
        //Si soy Inspector-Grabador
        if (this.isGrabador && this.isInspector) {
            //estado solicitud en Revision Solicitante
            if (this.solicitudDocumentoEx.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE) {
                return this.checkDelete() && this.laHeGrabadoYo;
            }

            //estado CF
            if (this.solicitudDocumentoEx.IdEstadoCertificadoFitoEx != EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE) {
                //es posible que haya documentos ya adjuntados al ePhyto y esté enviado a Traces, entonces evitar editar/eliminar documentos. El inspector sólo puede editar los suyos NO adjuntados
                return this.checkDelete() && item.IdUsuario == this.loggedInUser?.Id && !item.AttachedEphyto && !item.Autogenerado;
            } else {
                return this.checkEdit();
            }
        } else {
            //es posible que haya documentos ya adjuntados al ePhyto y esté enviado a Traces, entonces evitar editar/eliminar documentos.
            return this.checkDelete() && !item.AttachedEphyto && !item.Autogenerado;
        }
    }

    checkEdit() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_EXPORTACION, this.solicitudDocumentoEx.IdEstadoSolicitudEx).Editable;
    }

    checkDelete() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_EXPORTACION, this.solicitudDocumentoEx.IdEstadoSolicitudEx).Visible;
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    //Para pipe de visualización de iconos en tabla documentos
    //Columna Autogenerado de tabla TDocumentoSolicitudEx: Diferencia los emitidos automáticamente por el sistema de los subidos manualmente por los usuarios
    //      Autogenerado + CF       pinta icono de Sede Electrónica
    //      Autogenerado + ePhyto   pinta icono de Traces
    //Columna AttachedEphyto de tabla TDocumentoSolicitudEx: Indica si un documento se ha anexado al ePhyto para su envío a Traces
    isTracesInfoVisible(item: TDocumentoSolicitudExViewModel, field: string) {
        switch (field) {
            case 'Autogenerado':
                return item.Autogenerado;
            //return item.Autogenerado && item.EsEphyto; //para que pinte el icono de Traces, tiene que ser Autogenerado + ePhyto

            case 'AttachedEphyto':
                return item.AttachedEphyto;
        }
    }

    createForm() {
        this.form = this.fb.group({
            IdTipoDocumentacionEx: '',
            txtTexto: '',
            Fecha: null,
            IdPais: null,
            Perfil: '',
        });
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.navMenuService.currentSolicitudExportacion.Id]);
    }

    onAdd() {
        this.router.navigate([this.router.url, 'create']);
    }

    onEdit(item: TDocumentoSolicitudExViewModel) {
        this.router.navigate([this.router.url, 'detalleDocumento', item.Id]);
    }

    onDownload(item: TDocumentoSolicitudExViewModel) {
        this.uploadedFile.Guid = item.CodigoStorage;
        this.uploadedFile.Name = item.NombreArchivo;

        this.uploaderService.download(this.uploadedFile).subscribe(res => {
            this.OpenDownloadedFile(res);
        });
    }

    onDelete(item: TDocumentoSolicitudExViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.documentosExService.deleteDocumento(item.Id).subscribe(() => {
                    this.addSuccessMessage('Documento eliminado correctamente');
                    this.onSearchButton();
                });
            },
        });
    }
}
